function u(e, h, t) {
  h /= 100, t /= 100;
  const n = h * Math.min(t, 1 - t) + t;
  return [e, n ? (2 - 2 * t / n) * 100 : 0, n * 100];
}
function M(e, h, t) {
  h /= 100, t /= 100;
  const n = t - t * h / 2, a = Math.min(n, 1 - n);
  return [e, a ? (t - n) / a * 100 : 0, n * 100];
}
function c(e, h, t) {
  h /= 100, t /= 100;
  let n = (a, i = (a + e / 60) % 6) => t - t * h * Math.max(Math.min(i, 4 - i, 1), 0);
  return [n(5) * 255, n(3) * 255, n(1) * 255];
}
function o(e, h, t) {
  e /= 255, h /= 255, t /= 255;
  let n = Math.max(e, h, t), a = n - Math.min(e, h, t), i = a && (n == e ? (h - t) / a : n == h ? 2 + (t - e) / a : 4 + (e - h) / a);
  return [60 * (i < 0 ? i + 6 : i), n && a / n * 100, n * 100];
}
function f(e, h, t) {
  e /= 255, h /= 255, t /= 255;
  let n = Math.max(e, h, t), a = n - Math.min(e, h, t), i = 1 - Math.abs(n + n - a - 1), m = a && (n == e ? (h - t) / a : n == h ? 2 + (t - e) / a : 4 + (e - h) / a);
  return [60 * (m < 0 ? m + 6 : m), i ? a / i * 100 : 0, (n + n - a) * 50];
}
function s(e, h, t) {
  h /= 100, t /= 100;
  let n = h * Math.min(t, 1 - t), a = (i, m = (i + e / 30) % 12) => t - n * Math.max(Math.min(m - 3, 9 - m, 1), -1);
  return [a(0) * 255, a(8) * 255, a(4) * 255];
}
export {
  u as hsl2hsv,
  s as hsl2rgb,
  M as hsv2hsl,
  c as hsv2rgb,
  f as rgb2hsl,
  o as rgb2hsv
};
